module.exports = __webpack_public_path__ + "zmenseni-prsou_5_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_5_before.jpg
// module id = 1286
// module chunks = 0